<p-panel [styleClass]="panelStyleClass">
  <ng-template pTemplate="header" *ngIf="Config?.Title">
    <span class="p-panel-title ng-star-inserted padding-15">{{
      Config?.Title
    }}</span>
  </ng-template>
  <ng-template pTemplate="icons">
    <div class="flex gap-2 mr-2">
      <p-button
        *ngFor="let iconbutton of Config?.IconButton"
        text
        styleClass="{{ iconbutton?.GetButtonClass()?.styleClass }}"
        [style]="{ height: '20px' }"
        [icon]="getHeaderIcon(iconbutton?.GetButtonClass()?.icon)"
        [label]="getHeaderTitle(iconbutton?.GetButtonClass()?.title)"
        [disabled]="iconbutton?.GetDisableAction()"
        (onClick)="iconbutton?.GetButtonAction(rowData)"
      />
    </div>
  </ng-template>

  <p-table
    [value]="!loading ? getResults() : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
    [scrollable]="true"
    [tableStyle]="tableStyle"
    [styleClass]="styleClass"
    [dataKey]="dataKey"
    (onLazyLoad)="onLazyLoad($event)"
    [lazy]="lazy"
    [lazyLoadOnInit]="lazyLoadOnInit"
    [paginator]="paginator"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [rows]="rows"
    [totalRecords]="getTotal()"
    (onPage)="onPageChange($event)"
  >
    <ng-template pTemplate="header">
      <tr [class]="headerStyleClass">
        <th
          *ngIf="Config?.LineNumbers"
          pFrozenColumn
          [frozen]="true"
          alignFrozen="left"
        >
          Α/Α
        </th>
        <th
          *ngFor="let header of Config?.Columns"
          [pSortableColumnDisabled]="!header?.GetSort()"
          [pSortableColumn]="header?.GetPropertyName()"
          pFrozenColumn
          [frozen]="header?.frozen ?? false"
          [alignFrozen]="header?.alignFrozen ?? 'left'"
        >
          {{ header?.GetName() }}
          <p-sortIcon
            [field]="header?.GetPropertyName()"
            *ngIf="header?.GetSort()"
          />
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr *ngIf="isTableVisible" class="p-table-hover">
        <ng-container *ngIf="loading">
          <td *ngFor="let c of getLoadingColumns()">
            <p-skeleton />
          </td>
        </ng-container>

        <ng-container *ngIf="!loading">
          <td *ngIf="Config?.LineNumbers" pFrozenColumn alignFrozen="left">
            <div class="flex align-items-center gap-2">
              {{
                lazy
                  ? rowIndex + 1
                  : rowIndex + 1 + (getCurrentPage() - 1) * rows
              }}
            </div>
          </td>

          <ng-container *ngFor="let column of Config?.Columns">
            <td
              *ngIf="column?.GetPropertyName()"
              [ngClass]="{
                'w-1rem':
                  column?.GetColumnType() === ColumnTypeEnum.ButtonColumn
              }"
              [frozen]="column?.frozen ?? false"
              pFrozenColumn
              [alignFrozen]="column?.alignFrozen ?? 'left'"
            >
              <div [ngSwitch]="column.GetColumnType()">
                <div *ngSwitchCase="ColumnTypeEnum.TextColumn">
                  <a
                    [pTooltip]="getTooltip(column?.GetTooltip(), item)"
                    [escape]="false"
                  >
                    {{
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                    }}
                  </a>
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.DateColumn">
                  <a [pTooltip]="getTooltip(column?.GetTooltip(), item)">
                    {{
                      getValue(
                        column.GetValue(item[column.GetPropertyName()]),
                        item[column.GetPropertyName()]
                      ) ?? "-"
                    }}
                  </a>
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.CurrencyColumn">
                  <a [pTooltip]="getTooltip(column?.GetTooltip(), item)">
                    {{
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                    }}
                  </a>
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.IconColumn">
                  <i
                    class="pi pi-{{
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                    }}"
                    style="font-size: 1rem"
                    [pTooltip]="getTooltip(column?.GetTooltip(), item)"
                  >
                  </i>
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.LabelColumn">
                  <p-badge
                    [value]="
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                    "
                    [severity]="
                      column?.GetSeverity(item[column.GetPropertyName()])
                    "
                    [pTooltip]="getTooltip(column?.GetTooltip(), item)"
                  />
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.BooleanColumn">
                  <p-badge
                    [value]="
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                        ? 'ΝΑΙ'
                        : 'ΟΧΙ'
                    "
                    [severity]="
                      column?.GetSeverity(item[column.GetPropertyName()])
                    "
                    [pTooltip]="getTooltip(column?.GetTooltip(), item)"
                  />
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.HyperlinkColumn">
                  <a
                    [href]="
                      getValue(column.GetValue(), item[getFileUrl(column)])
                    "
                    [pTooltip]="getTooltip(column?.GetTooltip(), item)"
                  >
                    {{
                      getValue(
                        column.GetValue(),
                        item[column.GetPropertyName()]
                      )
                    }}
                  </a>
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.ButtonColumn">
                  <p-button
                    *ngIf="column?.GetIsVisible(item)"
                    [icon]="
                      getIcon(column?.GetColumnClassProperties()?.icon, item) ??
                      'pi pi-eye'
                    "
                    [label]="
                      getTitle(
                        column?.GetColumnClassProperties()?.title,
                        item
                      ) ?? ''
                    "
                    styleClass="p-button-rounded p-button-text {{
                      getStyleClass(
                        column?.GetColumnClassProperties()?.styleClass,
                        item
                      ) ?? 'p-button-info'
                    }}"
                    [style]="
                      column?.GetColumnClassProperties()?.style ??
                      { width: '35px', height: '35px' }
                    "
                    [pTooltip]="
                      getTooltip(
                        column?.GetColumnClassProperties()?.pTooltip,
                        item
                      ) ?? ''
                    "
                    [tooltipPosition]="
                      column?.GetColumnClassProperties()?.tooltipPosition ??
                      'left'
                    "
                    (onClick)="column?.GetAction(item, $event)"
                    [disabled]="column?.GetIsDisabled(item) ?? false"
                  />
                </div>
                <div *ngSwitchCase="ColumnTypeEnum.CustomColumn">
                  <ng-container
                    *ngTemplateOutlet="
                      customTemplates[column.GetPropertyName()];
                      context: {
                        config: column.GetValue(item[column.GetPropertyName()])
                      }
                    "
                  />
                </div>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>

  <div
    class="mt-4 flex justify-content-center align-items-center"
    *ngIf="Config && Config.Paging ? true : false"
  >
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="getFirst()"
      [rows]="getPagesize()"
      [totalRecords]="getTotal()"
      [rowsPerPageOptions]="rowsPerPageOptions"
      class="custom-paginator"
    />
  </div>
</p-panel>
